<h4>{{ 'FARM.MY_FARMS' | translate }}</h4>
  <div fxLayout="row wrap" class="col-gap">
    <div fxFlex.xs="100" fxFlex.sm="100" fxFlex.md="40" fxFlex.lg="40" fxFlex.xl="40" *ngFor="let farm of farmCards | async; let i = index">
      <mat-card class="example-card">
        <mat-card-header>
          <div mat-card-avatar class="example-header-image"></div>
          <mat-card-title>{{ 'FARM.FARM_NUMBER' | translate }}{{i+1}}</mat-card-title>
          <mat-card-subtitle>
            <b><div *ngIf="farm.townHallDTO && farm.provinceDTO">
              {{ 'FARM.COUNTRY.SPAIN' | translate }}<br>
            </div>
            <div *ngIf="farm.municipalityDTO && farm.districtDTO">
              {{ 'FARM.COUNTRY.PORTUGAL' | translate }}<br>
            </div></b>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <b><div *ngIf="farm.townHallDTO && farm.provinceDTO">
            {{farm.provinceDTO?.provinceName}}<br>
            {{farm.townHallDTO?.townHallName}}<br>
          </div>
          <div *ngIf="farm.municipalityDTO && farm.districtDTO">
            {{farm.districtDTO?.districtName}}<br>
            {{farm.municipalityDTO?.municipalityName}}<br>
          </div></b>
          {{farm.area}} {{ 'FARM.MEASURE' | translate }}<br>
          <i>{{ farm.available ? ('FARM.AVAILABLITY.AVAILABLE' | translate) : ('FARM.AVAILABLITY.NOT_AVAILABLE' | translate) }}</i>
        </mat-card-content>
        <mat-card-actions class="text-align: center">
          <button mat-raised-button color="primary" class="ml-1" (click)="editFarm(farm.id)">
            {{ 'REGISTER.EDIT' | translate }}</button>
          <button mat-raised-button color="accent" class="ml-1" (click)="deleteFarm(farm)">{{ 'REGISTER.DELETE' | translate }}</button>
        </mat-card-actions>
      </mat-card>
    </div>
  </div>
<mat-paginator [pageSizeOptions]="[4, 8, 12]"></mat-paginator>